import React from 'react'
import req from '@sportninja/common/api/request'
// @ts-ignore Mixed JS module without declarations in this workspace.
import { store } from '@sportninja/common/store'
import { ActionType, ProfileAction } from '../context/ProfileContext/types'
import { ProfileIdentifier, ProfilePlayer, ProfileUser } from '../types'

/**
 * Loads the current user profile, preferring Redux state before falling back to API.
 */
export const loadProfileItem = async (
  dispatch: React.Dispatch<ProfileAction>,
  forceApi = false
): Promise<void> => {
  if (!forceApi) {
    const reduxUser = store?.getState?.()?.auth?.user as ProfileUser | undefined
    if (reduxUser && reduxUser.id && reduxUser.name_first) {
      dispatch({ type: ActionType.SET_ITEM, payload: reduxUser })
      return
    }
  }

  try {
    const response = await req('/users/me2')
    dispatch({ type: ActionType.SET_ITEM, payload: response.data })
  } catch (error) {
    console.error('🚨 loadProfileItem: Failed to load profile item', error)
  }
}

/**
 * Loads players for the current user and derives the stats visibility state.
 */
export const loadProfilePlayers = async (
  dispatch: React.Dispatch<ProfileAction>
): Promise<void> => {
  try {
    const response = await req('/users/me/players3')
    const players = (response.data || []) as ProfilePlayer[]

    if (players.length > 0) {
      const selfPlayerIds = [
        ...new Set<ProfileIdentifier>(players.map((player) => player.id)),
      ]

      dispatch({
        type: ActionType.SET_PLAYERS,
        payload: {
          players,
          selfPlayerIds,
          showStats: true,
        },
      })
      return
    }

    dispatch({
      type: ActionType.SET_PLAYERS,
      payload: {
        players: [],
        selfPlayerIds: [],
        showStats: false,
      },
    })
  } catch (error) {
    console.error(
      '🚨 loadProfilePlayers: Failed to load profile players',
      error
    )
    dispatch({ type: ActionType.SET_LOADED_PLAYERS, payload: true })
  }
}
